import { DataModel } from "common/models/utility-models/base-model";

export class zoneListModel extends DataModel {
  override id: '';
  zone_name: '';
}